import request from '@/utils/request'

export const getJournalEntries = params => request.get('/accounting/journal-entries', { params })

export const getJournalEntry = id => request.get(`/accounting/journal-entries/${id}`)

export const createJournalEntry = data => request.post('/accounting/journal-entries', data)

export const updateJournalEntry = (id, data) => request.put(`/accounting/journal-entries/${id}`, data)

export const deleteJournalEntry = id => request.delete(`/accounting/journal-entries/${id}`)

export const postJournalEntry = id => request.post(`/accounting/journal-entries/${id}/post`)

export const reverseJournalEntry = (id, data = {}) => request.post(`/accounting/journal-entries/${id}/reverse`, data)
